import {Row, Col, message} from 'antd';
import { useHistory } from 'react-router-dom';
import InstitutionCard from '../InstitutionCard';
import BaseTitle from '../BaseTitle';
import EmptyData from '../EmptyData';
import s from './index.module.css';
import {getOrg} from "../../server/api";
import {useEffect, useState} from "react";

const InstitutionSection = ({ selectedModule  }) => {
  const history = useHistory();

  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    if (selectedModule && selectedModule.code) {
      requestOrgs();
    }
  }, [selectedModule])

  const requestOrgs = async () => {
    let params = {
      pageSize: 8,
      pageNo: 1,
      category: selectedModule.code
    };
    getOrg(params)
        .then(function (res) {
          const { status, data: { result } } = res;
          if (status === 200) {
            setOrgs(result.records);
            return;
          }
          message.error('查询数据出错，请刷新重试！');
        })
        .catch(function (error) {
        });
  }

  const institutionData = [
    {
      id: 1,
      name: '甘肃建宇工程质量检测有限责任公司',
      types: ['工程检测', '工程检测'],
      phone: '18139937767',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府7号',
      views: 216
    },
    {
      id: 2,
      name: '甘肃中建工程检测有限公司',
      types: ['工程检测', '材料检测'],
      phone: '18139937769',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府7号',
      views: 216
    },
    {
      id: 3,
      name: '庆阳市建筑工程质量检测中心',
      types: ['工程检测', '结构检测'],
      phone: '18139937768',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府7号',
      views: 216
    },
    {
      id: 4,
      name: '甘肃中建工程检测有限公司',
      types: ['工程检测', '材料检测'],
      phone: '18139937769',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府7号',
      views: 216
    },
    {
      id: 5,
      name: '甘肃中建工程检测有限公司',
      types: ['工程检测', '材料检测'],
      phone: '18139937769',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府7号',
      views: 216
    },
    {
      id: 6,
      name: '甘肃建宇工程质量检测有限责任公司',
      types: ['工程检测', '工程检测'],
      phone: '18139937767',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府7号',
      views: 216
    },
    {
      id: 7,
      name: '甘肃中建工程检测有限公司',
      types: ['工程检测', '材料检测'],
      phone: '18139937769',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府7号',
      views: 216
    },
    {
      id: 8,
      name: '甘肃中华工程检测有限公司',
      types: ['工程检测', '材料检测'],
      phone: '18139937768',
      address: '甘肃省庆阳市西峰区岐黄大道庆阳市政府12号',
      views: 216
    }
  ];

  const handleInstitutionClick = (institution) => {
    history.push(`/institutions/${institution.id}`);
  };

  const handleViewMore = () => {
    history.push('/institutions');
  };

  return (
    <div className={s.institutionSection}>
      <BaseTitle
        title={selectedModule?.modelTitle1}
        subtitle={selectedModule?.modelDesc1}
      />

      <Row gutter={[16, 16]} className={s.institutionCards}>
        {orgs && orgs.length > 0 ? (
          orgs.map((institution) => (
            <Col xs={24} sm={12} md={8} lg={6} xl={6} key={institution.id}>
              <InstitutionCard
                institution={institution}
                onClick={handleInstitutionClick}
              />
            </Col>
          ))
        ) : (
          <Col span={24}>
            <EmptyData description="暂无机构数据" />
          </Col>
        )}
      </Row>

      {orgs && orgs.length > 0 && (
        <div className={s.institutionMore}>
          <a href="#" className={s.moreLink} onClick={(e) => { e.preventDefault(); handleViewMore(); }}>查看更多</a>
        </div>
      )}
    </div>
  );
};

export default InstitutionSection;
